import { render } from "./OtorrinolaringologiaForm.vue?vue&type=template&id=6a756d7c&scoped=true"
import script from "./OtorrinolaringologiaForm.vue?vue&type=script&lang=js"
export * from "./OtorrinolaringologiaForm.vue?vue&type=script&lang=js"

import "@/assets/css/listaRegistros.css?vue&type=style&index=0&id=6a756d7c&scoped=true&lang=css"
import "@/assets/css/especialidades.css?vue&type=style&index=1&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a756d7c"]])

export default __exports__